<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';

import AbTestForm from './AbTestForm.vue';

const props = defineProps({
  whatsappTemplateCategory: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const handleSubmit = async params => {
  try {
    await store.dispatch('campaigns/createAbTest', params);
    useAlert(t('CAMPAIGN.WHATSAPP.AB_TEST.SUCCESS'));
    emit('close');
  } catch {
    useAlert(t('CAMPAIGN.WHATSAPP.AB_TEST.ERROR'));
  }
};

const handleClose = () => emit('close');
</script>

<template>
  <div
    class="w-[28rem] z-50 min-w-0 absolute top-10 ltr:right-0 rtl:left-0 bg-n-alpha-3 backdrop-blur-[100px] rounded-xl border border-n-weak shadow-md max-h-[80vh] overflow-y-auto"
  >
    <div class="p-6 flex flex-col gap-6">
      <h3 class="text-base font-medium text-n-slate-12 flex-shrink-0">
        {{ t('CAMPAIGN.WHATSAPP.AB_TEST.TITLE') }}
      </h3>
      <AbTestForm
        :whatsapp-template-category="props.whatsappTemplateCategory"
        @submit="handleSubmit"
        @cancel="handleClose"
      />
    </div>
  </div>
</template>
